import { render } from "./HelloWorld.vue?vue&type=template&id=4490169f&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=4490169f&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-4490169f"

export default script